import React from 'react';
import { Card, spacing, useTheme } from '@fti/design-system';
import type { DatasetWithPreview } from '../../types/dataset';

interface ImportSummaryProps {
  dataset: DatasetWithPreview;
}

export const ImportSummary: React.FC<ImportSummaryProps> = ({ dataset }) => {
  const { theme } = useTheme();

  const formatLabel = dataset.file_format.toUpperCase();
  const importDate = new Date(dataset.imported_at + 'Z').toLocaleString();

  return (
    <Card variant="elevated">
      <Card.Body>
        <div>
          <p
            style={{
              margin: 0,
              fontWeight: 600,
              fontSize: '1rem',
              color: theme.colors.text.primary,
            }}
          >
            {dataset.filename}
          </p>

          <dl
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: `${spacing.xs} ${spacing.md}`,
              margin: `${spacing.sm} 0 0 0`,
              fontSize: '0.9rem',
            }}
          >
            <dt style={{ color: theme.colors.text.secondary }}>Format</dt>
            <dd style={{ margin: 0, color: theme.colors.text.primary }}>{formatLabel}</dd>

            <dt style={{ color: theme.colors.text.secondary }}>Rows</dt>
            <dd style={{ margin: 0, color: theme.colors.text.primary }}>
              {dataset.row_count.toLocaleString()}
            </dd>

            <dt style={{ color: theme.colors.text.secondary }}>Columns</dt>
            <dd style={{ margin: 0, color: theme.colors.text.primary }}>
              {dataset.column_count.toLocaleString()}
            </dd>

            <dt style={{ color: theme.colors.text.secondary }}>Imported</dt>
            <dd style={{ margin: 0, color: theme.colors.text.primary }}>{importDate}</dd>
          </dl>
        </div>
      </Card.Body>
    </Card>
  );
};
